/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BottleIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "bottle", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M9.5 4.78804C9.5 5.8206 9.17266 6.82274 8.57284 7.6632C7.60216 9.0233 7 10.06 7 12C7 14.0487 7 18.4293 7 21.0014C7 22.106 7.89543 23 9 23L16 23C17.1046 23 18 22.1074 18 21.0028C18 18.1223 18 13.0329 18 12C18 10.06 17.3978 9.0233 16.4272 7.6632C15.8273 6.82274 15.5 5.8206 15.5 4.78804L15.5 3.5C15.5 2.94771 15.0523 2.5 14.5 2.5L10.5 2.5C9.94772 2.5 9.5 2.94771 9.5 3.5L9.5 4.78804Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7 12H18M7 19H18", stroke: "currentColor" }),
        React.createElement("path", { d: "M15.5 5.5L9.5 5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BottleIcon);
export default ForwardRef;
//# sourceMappingURL=bottleIcon.js.map